<template>
    <div style="max-height: 35vh">
        <GPIOReadingsList
            :station="props.station"
            @selected-value="setSelectedRows"
        />
    </div>
</template>
<script setup lang="ts">
import type { GPIOReading } from '@/objects/generated';
import { ref } from 'vue';
import GPIOReadingsList from './GPIOReadingsList.vue';

const props = withDefaults(
    defineProps<{
        /**
         * The station to filter on.
         */
        station?: 'all' | 'start' | 'finish' | number;

        /**
         * The current selected row
         */
        selectedValue?: {
            rows: GPIOReading[];
        };
    }>(),
    {
        station: 'all',
        selectedValue: () => ({ rows: [] }),
    },
);

// The selected rows in the grid
const internalSelectedRows = ref(props.selectedValue);

// Callback for the emitted selected rows
const setSelectedRows = (selectedRows: GPIOReading[]) => {
    internalSelectedRows.value.rows = selectedRows;
};
</script>
